import { isSameId } from "../../helpers";
export default function (store, { id }) {
    if (!store.existsTask(id)) {
        return;
    }
    const state = store.getState();
    let { selected, tasks } = state;
    const tasksMap = state.tasksMap;
    const childrenIds = store.getChildrenIds({ id, tree: true });
    const removeIds = [id, ...childrenIds];
    const originalTask = { ...tasksMap[id] };
    originalTask.selected = false;
    const targetId = store.getNearId({ id, dir: "prev" });
    let reverse = false;
    if (!targetId)
        reverse = true;
    const kids = [];
    for (const removed of removeIds) {
        selected = selected.filter(i => !isSameId(i, removed));
        tasks = tasks.filter(i => {
            const found = isSameId(i.id, removed);
            if (found && i.id !== id)
                kids.push(i);
            return !found;
        });
        delete tasksMap[removed];
    }
    const { treeTasks, childrenMap, filteredChildrenMap, usersMap, tags } = store.getInnerState(tasks, state.activeProject);
    store.setState({
        tasks,
        treeTasks,
        childrenMap,
        filteredChildrenMap,
        usersMap,
        tags,
        selected,
        tasksMap,
    });
    return () => {
        const data = {
            id: originalTask.id,
            task: originalTask,
            reverse,
            $meta: {
                skipHistory: true,
                restore: id,
            },
        };
        if (targetId) {
            data.targetId = targetId;
        }
        if (originalTask.project) {
            data.project = originalTask.project;
        }
        if (originalTask.parent) {
            data.parent = originalTask.parent;
        }
        store.in.exec("add-task", data);
        kids.forEach((kid) => {
            const data = {
                id: kid.id,
                task: kid,
                parent: kid.parent,
                $meta: {
                    skipHistory: true,
                    restore: kid.id,
                },
            };
            if (kid.project) {
                data.project = kid.project;
            }
            store.in.exec("add-task", data);
        });
    };
}
//# sourceMappingURL=delete.js.map